Array.from(document.querySelectorAll('input[type=file]')).forEach(function(el){
    el.addEventListener('change', function(){
        if(this.files[0]){
            document.querySelector('label[for='+this.id+']').innerHTML = this.files[0].name;
        }
    })
})